import React, { useState } from 'react';
import SlideItemComponent from "./SlideItemComponent";
import { ReactComponent as SlidesGridBg } from "./SlidesGridBg.svg";
import { ReactComponent as SlideItemsGlowBg } from "./SlideItemsGlowBg.svg";
import { ReactComponent as SlidesLightRect } from "./SlidesLightRect.svg";

const SlideItemsComponent = () => {
	const [currentIndex, setCurrentIndex] = useState(0);
	
	const slidesDate = [
		{
			id: 0,
			firstText: "NFD Trade Bots gives you the ability to trade any tokens quickly and conveniently within a single interface inside Telegram.",
			secondText: "The bot's functionality offers unique features, and precise customization will give you an edge over other market participants."
		},
		{
			id: 1,
			firstText: "And all of this is available in a single app.",
			secondText: "Explore the information on the website \n" +
				"to learn more about each feature."
		},{
			id: 2,
			firstText: "Automatically track the appearance of contracts on Twitter and Telegram and purchase the necessary tokens in stealth mode before other market participants.",
			secondText: ""
		},{
			id: 3,
			firstText: "Use copy trading, limit orders, stop losses, and take profits, as well as add your custom RPCs to achieve unmatched transaction confirmation speed.",
			secondText: ""
		},
	];
	
	const entries = Object.entries(slidesDate);
	const n = entries.length;
	
	const handleClick = (increment: number) => {
		setCurrentIndex((prevIndex) => (prevIndex + increment + n) % n);
	};
	
	return (
		<div className="slideItemsComponent">
			<div className="slideItemsComponent_grid">
				<SlidesGridBg />
			</div>
			<div className="slideItemsComponent_glow">
				<SlideItemsGlowBg />
			</div>
			<div className="slideItemsComponent_carousel">
				{entries.map(([key, value], index) => (
						<SlideItemComponent
							key={`${key}-${value.id}-${index}`}
							id={value.id}
							index={currentIndex}
							setIndex={handleClick}
							firstText={value.firstText}
							secondText={value.secondText}
						/>
				))}
			</div>
			
			<div className="accents">
				<div className="light"></div>
				<div className="light sm"></div>
				<div className="top-light"></div>
				<div className="top-light-blur"></div>
				<div className="top-light-rect">
					<SlidesLightRect />
				</div>
			</div>
		</div>
	);
};

export default SlideItemsComponent;